import { css, keyframes } from '@emotion/react';

export const rotateAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const spinnerStyles = css`
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
`;

export const circleStyles = css`
    position: absolute;
    width: 64px;
    height: 64px;
    animation: ${rotateAnimation} 1.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;

    &:nth-of-type(1) {
        animation-delay: -0.45s;
    }
    &:nth-of-type(2) {
        animation-delay: -0.3s;
    }
    &:nth-of-type(3) {
        animation-delay: -0.15s;
    }
`;
